import { render, staticRenderFns } from "./IconLinkOutline.vue?vue&type=template&id=2218d080"
import script from "./IconLinkOutline.vue?vue&type=script&lang=js"
export * from "./IconLinkOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports